import getDatesIntervalWithSubtractMinutes from '../../../localUtils/getDatesIntervalWithSubtractMinutes'

export default function getSixHourAgo() {
  const sixHoursInMinutes = 6 * 60

  const dates = getDatesIntervalWithSubtractMinutes(sixHoursInMinutes)

  const options = {
    name: 'SIX_HOURS_AGO',
    label: '6 horas',
    ...dates,
  }

  return options
}
